import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const state = {
  glassesFrame: [],
  glassesLens: [],
  contantLens: [],
  hearingAid: [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
